import { render, staticRenderFns } from "./MasaDolulukOranlari.vue?vue&type=template&id=2a49433f&"
import script from "./MasaDolulukOranlari.vue?vue&type=script&lang=js&"
export * from "./MasaDolulukOranlari.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports